import ApiError from 'util/api/errors/ApiError';

const ERROR_DETAIL_NOT_FOUND = 'ITEM_NOT_FOUND';
const ERROR_MESSAGE_NOT_FOUND = 'Sorry, the resource was not found.';

export default class NotFoundError extends ApiError {
    constructor(response) {
        super(ERROR_MESSAGE_NOT_FOUND, response, ERROR_DETAIL_NOT_FOUND);
    }
}



// WEBPACK FOOTER //
// ./src/util/api/errors/NotFoundError.js